var jade = require("/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div vueinit props=\"{ createOrEditBeleg: vm.createOrEditBeleg }\"><vue-belege-list v-bind:create-or-edit-beleg=\"propsAngular.createOrEditBeleg\"></vue-belege-list></div>");;return buf.join("");
}